import React from 'react';
import Layout from '../../components/Layout';

const BlogPage2 = () => {
  return (
    <Layout>
      <section className="section">
        <div className="content is-medium">
          <h1>Three Ideas for Post Wedding Couple Photoshoot Photography</h1>
          <p>
            A wedding is certainly an important event in our lives. Not just for
            the bride and the groom but their families, friends, and all those
            who helped to make the day memorable. A wedding is not just about
            the Sangeet or the Mehendi function or the bachelor (or
            bachelorette) party or the D day itself! It is about every intricate
            details that the groom and bride and the friends and family who have
            carefully put together to make this day the most important day of
            our lives
          </p>

          <p>
            As professional wedding photographers, we have ensured that we
            captured these moments of great significance as a frame and gift
            them back to you as your wedding album – an event that marks a very
            important bond in your lives; the arrival of your spouse, your life
            partner, your ‘other you.’
          </p>
        </div>
      </section>
    </Layout>
  );
};

export default BlogPage2;
